import styled from 'styled-components'

const SignInFormContainer = styled.div`
  background-color: #ffffff;
  border: 1px solid #c9d7df;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 42px 60px 42px;
  width: 360px;
  margin: 0 auto;
`

export default SignInFormContainer



// WEBPACK FOOTER //
// ./src/components/signin/SignInFormContainer.js